class DetailsDisclosure extends HTMLElement {
  constructor() {
    super()
    this.header = document.querySelector('.header')
    this.mainDetailsToggle = this.querySelector('details')
    this.headerMenuItem = this.querySelector('.header__menu-item')
    this.cartCountText = document.querySelector('.cart-count-bubble span')
    this.headerMenuItem.addEventListener(
      'click',
      this.onMenuItemClick.bind(this)
    )
    this.mainDetailsToggle.addEventListener(
      'focusout',
      this.onFocusOut.bind(this)
    )
  }

  onMenuItemClick() {
    if (this.header.getAttribute('style')) {
      if (this.cartCountText) {
        this.cartCountText.removeAttribute('style')
      }
      this.header.removeAttribute('style')
    } else {
      if (this.cartCountText) {
        this.cartCountText.style.color = 'white'
      }
      this.header.style.background = 'white'
      this.header.style.color = '#323530'
    }
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close()
    })
  }

  close() {
    this.header.removeAttribute('style')
    if (this.cartCountText) {
      this.cartCountText.removeAttribute('style')
    }
    this.mainDetailsToggle.removeAttribute('open')
    this.mainDetailsToggle
      .querySelector('summary')
      .setAttribute('aria-expanded', false)
  }
}

customElements.define('details-disclosure', DetailsDisclosure)
